const AmountFormatter = ({amount}) => {
  const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2, // minimum number of fractional digits
      maximumFractionDigits: 2, // maximum number of fractional digits
    });
  return (<>
  {amount ? formatter.format(amount) : formatter.format(0)}
  </>);
}

export default AmountFormatter;